module.exports = __webpack_public_path__ + "img/template-img.b18ecdb3.svg";